import { Input, Form } from 'antd'
import React from 'react'

const InputTextUC = (props) => {
    const { className, name, ...resProp } = props
    return (
        <>
            <Form.Item
                name={name}
            >
                <Input className={'input-text-custom ' + className} {...resProp} />
            </Form.Item>
        </>
    )
}

export default InputTextUC